export default {
  timeout: 700,
  floorPrices: {
    floor: 0.01,
    monday: 0.01,
    tuesday: 0.01,
    wednesday: 0.01,
    thursday: 0.01,
    friday: 0.01,
    saturday: 0.01,
    sunday: 0.01
  },
  analytics: {
    rubicon: 12736
  },
  priceBuckets: {
    buckets: [
      {
        precision: 2,
        min: 0,
        max: 5,
        increment: 0.05
      },
      {
        precision: 2,
        min: 5,
        max: 10,
        increment: 0.1
      },
      {
        precision: 2,
        min: 10,
        max: 20,
        increment: 0.25
      },
      {
        precision: 2,
        min: 20,
        max: 50,
        increment: 1.0
      }
    ]
  },
  bidParams: {
    desktop: [
      {
        bidder: 'rubicon',
        params: {
          accountId: '12736',
          siteId: '129828',
          zoneId: '612414'
        }
      },
      {
        bidder: 'appnexus',
        params: {
          placementId: '11087283'
        }
      },
      {
        bidder: 'appnexus',
        params: {
          placementId: '12209196'
        }
      },
      {
        bidder: 'openx',
        params: {
          unit: '538910929',
          delDomain: 'mansueto-d.openx.net'
        }
      },
      {
        bidder: 'trustx',
        params: {
          uid: '2813'
        }
      },
      {
        bidder: 'emxdigital',
        params: {
          placementId: '13866721'
        }
      },
      {
        bidder: 'aol',
        params: {
          placement: '',
          network: '9481.1'
        }
      }
    ],
    mobile: [
      {
        bidder: 'rubicon',
        params: {
          accountId: '12736',
          siteId: '87584',
          zoneId: '612410'
        }
      },
      {
        bidder: 'appnexus',
        params: {
          placementId: '11087280'
        }
      },
      {
        bidder: 'appnexus',
        params: {
          placementId: '12209196'
        }
      },
      {
        bidder: 'openx',
        params: {
          unit: '538910941',
          delDomain: 'mansueto-d.openx.net'
        }
      },
      {
        bidder: 'emxdigital',
        params: {
          placementId: '13866721'
        }
      },
      {
        bidder: 'trustx',
        params: {
          uid: '2814'
        }
      },
      {
        bidder: 'audienceNetwork',
        params: {
          placementId: ''
        }
      },
      {
        bidder: 'aol',
        params: {
          placement: '',
          network: '9481.1'
        }
      }
    ]
  },
  oopBidParams: [
    {
      bidder: 'unruly',
      params: {
        targetingUUID: '6f15e139-5f18-49a1-b52f-87e5e69ee65e',
        siteId: 1081534
      }
    }
  ]
};
